import axios from 'axios';
import { baseUrl, TOKEN_EXPIRED_CODE } from '@/utils/constant'
import { setToken, getToken } from '@/utils/auth'
import { Notification } from 'element-ui'
import store from '@/store'
import router from '@/router'

function getInitConfig () {
  const config = {
    baseURL: baseUrl,
    headers: {
      Authorization: getToken(),
      'Content-Type': 'application/json'
    }
  };
  return config;
}

const axiosInstance = axios.create(getInitConfig());

let timer;

axiosInstance.interceptors.request.use(
  config => {
    // 可以在此处打开全局忙等
    config.headers.Authorization = getToken();
    // console.log('getToken', config.headers.Authorization);
    return config;
  },
  err => {
    return Promise.reject(err);
  }
);

axiosInstance.interceptors.response.use(
  response => {
    const accessToken = response.headers['access_token']
    if (accessToken) {
      // console.log('setToken', accessToken);
      setToken(accessToken);
    }

    const { data } = response;
    // 未返回data属性，或code不是 200
    if (!data) {
      const errorMsg = data.message || '异常的响应数据';
      Notification.error({
        message: errorMsg
      })
      return Promise.reject(errorMsg)
    }
    let contentType = response['headers']['content-type'];
    if (contentType === 'application/x-download' || contentType === 'application/vnd.ms-excel' ||contentType === 'multipart/form-data;charset=utf-8') {
      return data;
    }

    // token过期，退出登录
    if (+data.code === TOKEN_EXPIRED_CODE) {
      Notification.warning({
        message: '当前会话已过期，请重新登录',
        duration: 3000,
        onClose: () => {
          store.dispatch('user/logout').then(() => {
            console.log('logout...');
            // window.location.replace(`${httpUrl}#/login`)
            router.push('/login')
          });
        }
      })
    } else if (+data.code !== 200 && data.code !== '000000') {
      if(response.request.responseType !== 'blob' && response.config.url !== 'qu-platform-auth-api/auth/tokenWithAD') {
        const errorMsg = data.message || '异常的响应数据';
        clearTimeout(timer);
        timer = setTimeout(_=>{
          Notification.error({
            message: errorMsg
          })
        },500)
        // Notification.error({
        //   message: errorMsg
        // })
        return Promise.reject(errorMsg)
      }
    }

    // TODO 此处可根据code做错误处理，如超时退出 未鉴权
    return data;
  },
  error => {
    let errorInfo = error.response
    let accessToken = '';
    let code = '';

    if (errorInfo) {
      accessToken = errorInfo.headers['access_token']
      code = errorInfo.data && errorInfo.data.code;
    }

    // 错误响应有token时，更新token
    if (accessToken) {
      // console.log('setToken-in-error', accessToken);
      !String(accessToken).includes('1000') && setToken(accessToken);
    }

    if (!errorInfo) {
      const { request: { statusText, status }, config } = JSON.parse(JSON.stringify(error))
      errorInfo = {
        statusText,
        status,
        request: { responseURL: config.url }
      }
    }

    // token过期
    if (+code === TOKEN_EXPIRED_CODE) {
      Notification.warning({
        message: '当前会话已过期，请重新登录',
        duration: 3000,
        onClose: () => {
          store.dispatch('user/logout').then(() => {
            console.log('logout...');
            // window.location.replace(`${httpUrl}#/login`)
            router.push('/login')
          });
        }
      })
      return Promise.reject(error)
    }

    clearTimeout(timer);
    timer = setTimeout(_=>{
      Notification.error({
        message: !errorInfo.data.message ? error.message : errorInfo.data.message
      })
    },500)

    // Notification.error({
    //   message: !errorInfo.data.message ? error.message : errorInfo.data.message
    // })
    

    return Promise.reject(error)
  }
);

export default axiosInstance;
